module.exports = __webpack_public_path__ + "static/61gde-f6d4e6fffbbcd4dd0cdc5ea29d33ed2f.gif";